import { useEffect, useState } from 'react'
import { subscribeOnlineIds } from '../../modules/Auth/providers/AuthSupabaseProvider/presenceHeartbeat'

const EMPTY = new Set()

export function useOnlineUserIds() {
  const [ids, setIds] = useState(EMPTY)

  useEffect(() => subscribeOnlineIds(setIds), [])

  return ids
}
